'use strict';

var _ = require('lodash');
var UserService = function UserService($q, $cookies, restangular, App, BootstrapService, User) {
  var PERMISSIONS_ALLOWED = ['read', 'write'];
  var COMPONENTS_CATEGORIES_TO_PRIVILEGE = ['system-status', 'system-configuration', 'user-exclusions', 'schedule-change'];
  function loadUser() {
    /*
     TODO: This need to be removed after portal integration is working 100% and Api allow change user.
      This is Forcing to get all the time AVRO user from the cookies,
     */
    return BootstrapService.loadUser();
  }
  function loadUserList() {
    return BootstrapService.loadUserList();
  }
  function loadNonAdminUserList() {
    return BootstrapService.loadNonAdminUserList();
  }
  function retrieveUserData() {
    return BootstrapService.retrieveUserData();
  }
  function retrieveUserList() {
    return restangular.one('users').get();
  }
  function retrieveNonAdminUserList() {
    return restangular.one('users').one('nonadminusers').get();
  }
  function retrieveSpecifiedUser(userID) {
    return restangular.one('user').one(userID).get();
  }
  function getSelfData() {
    return restangular.one('user').get();
  }
  function getCurrentUser() {
    return new User(App.User);
  }
  function getUserId() {
    return getCurrentUser().getUserId();
  }
  function getUserPrivileges() {
    return getCurrentUser().getUserPrivileges();
  }
  function getUserTimeZoneData() {
    return App.tzOffsets;
  }
  function categoryComponentsAsPermission(privileges, toExtendPermissions) {
    var groupPrivileges = _.chain(privileges).groupBy('category').transform(function (r, p, i) {
      var component = _.kebabCase(i);
      if (_.size(p) > 0 && _.includes(COMPONENTS_CATEGORIES_TO_PRIVILEGE, component)) {
        r[(component || '').toLowerCase()] = 'read';
      }
    }, []).value();
    _.extend(toExtendPermissions, groupPrivileges);
    return groupPrivileges;
  }
  function expectPrivilege(resource, expectedPrivilege) {
    if (!resource) {
      return false;
    }
    var privileges = getUserPrivileges();
    if (isUserSystemOwner()) {
      return true;
    }
    var reducedPrivileges = _.reduce(privileges, function (reducedPrivilege, privilege) {
      if (privilege.component === 'rules') {
        reducedPrivilege.rules = privilege.privilege.toLowerCase();
        reducedPrivilege.strategies = privilege.privilege.toLowerCase();
      }
      if (privilege.component === 'rom') {
        reducedPrivilege['rom-analysis'] = privilege.privilege.toLowerCase();
        reducedPrivilege['rom-summary'] = privilege.privilege.toLowerCase();
      } else {
        reducedPrivilege[privilege.component.toLowerCase()] = privilege.privilege.toLowerCase();
      }
      return reducedPrivilege;
    }, {});
    categoryComponentsAsPermission(privileges, reducedPrivileges);
    if (expectedPrivilege) {
      return reducedPrivileges[resource.toLowerCase()] === expectedPrivilege;
    }
    return _.indexOf(PERMISSIONS_ALLOWED, reducedPrivileges[resource.toLowerCase()]) !== -1;
  }
  function getPermissions(componentsName) {
    var results = {};
    componentsName.forEach(function (component) {
      results[component] = expectPrivilege(component);
    });
    return results;
  }
  function hasAuthorization(workFlow, expectedPermission, checkSuperPermission, superPermission) {
    if (checkSuperPermission) {
      return expectPrivilege(workFlow, expectedPermission) || expectPrivilege(workFlow, superPermission);
    }
    return expectPrivilege(workFlow, expectedPermission);
  }
  function removeUser() {
    $cookies.remove('iPlanetDirectoryPro');
  }
  function isUserSabreEmployee() {
    return _.get(getCurrentUser(), 'isSabreEmployee', false);
  }
  function isCurrentUserAnAdmin() {
    return _.get(getCurrentUser(), 'isAdmin', false) || isUserSystemOwner();
  }
  function getMarketsPreferences() {
    return getCurrentUser().getMarketPreferences();
  }
  function getLegsPreferences() {
    return getCurrentUser().getLegsPreferences();
  }
  function isUserSystemOwner() {
    return _.get(getCurrentUser(), 'isSystemOwner', false);
  }
  function refreshUserConfig() {
    return BootstrapService.refreshUserSettings();
  }
  function getUserDisplayNameFromId(userId) {
    var userList = App.userList;
    return _.find(userList, {
      userId: userId
    });
  }
  function getUserIdFromDisplayName(displayName) {
    var userList = App.userList;
    return _.chain(userList).filter(function (user) {
      return (user.getDisplayName() || '').toLowerCase() === (displayName || '').toLowerCase();
    }).first().value();
  }
  return {
    getCurrentUser: getCurrentUser,
    getUserPrivileges: getUserPrivileges,
    getUserTimeZoneData: getUserTimeZoneData,
    hasAuthorization: hasAuthorization,
    isUserSabreEmployee: isUserSabreEmployee,
    removeUser: removeUser,
    getUserId: getUserId,
    getSelfData: getSelfData,
    getPermissions: getPermissions,
    retrieveUserData: retrieveUserData,
    retrieveUserList: retrieveUserList,
    retrieveNonAdminUserList: retrieveNonAdminUserList,
    retrieveSpecifiedUser: retrieveSpecifiedUser,
    loadUser: loadUser,
    loadUserList: loadUserList,
    loadNonAdminUserList: loadNonAdminUserList,
    isCurrentUserAnAdmin: isCurrentUserAnAdmin,
    isUserSystemOwner: isUserSystemOwner,
    getMarketsPreferences: getMarketsPreferences,
    getLegsPreferences: getLegsPreferences,
    refreshUserConfig: refreshUserConfig,
    getUserIdFromDisplayName: getUserIdFromDisplayName,
    getUserDisplayNameFromId: getUserDisplayNameFromId
  };
};
UserService.$inject = ['$q', '$cookies', 'Restangular', 'App', 'BootstrapService', 'UserFactory'];
module.exports = UserService;